import { render, staticRenderFns } from "./ObjectHeaders.vue?vue&type=template&id=4813b8f4&"
import script from "./ObjectHeaders.vue?vue&type=script&lang=js&"
export * from "./ObjectHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports